import FilterRegister from "../../../../components/filter/register-basic";
import reqTipoProduto from "../../../../services/reqMultiTenant/reqTipoProduto";
import { RegisterProvider } from "../../register-matrix/context-api";
import MainRegisterMatrix from "../../register-matrix/main";
import Form from "../form";

const MainRegisterCategory = () => {
	const options = {
		id: "id_tipoproduto", //usado para saber qual field usar para atualizar
		ident: "categoryProduct", //usado para definir os event listners
		identFilter: "filterCategoryProduct", //usado para definir os event listners
		title: "Categoria de Produto",
		subTitle: "Cadastro",
		tableColumns: [
			{ key: "nome", label: "Nome", align: "left" },
			{ key: "ordem", label: "Ordem", align: "center" },
			{ key: "obs", label: "Observação", align: "left" },
			{ key: "empty2", label: "", align: "left" },
			{ key: "actions", label: "", align: "right" },
		],
		hasActive: true,
		parametersFilter: [{ id: 1, label: "Categoria", value: "nome" }],
	};

	const fetch = async (filterData, newPage) => {
		const { param, paramValue, active } = filterData; //contem active que retorna true ou false

		const response = await reqTipoProduto.listPaginate(param, paramValue, active, newPage);

		return response;
	};

	const fetchID = async (currentId) => {
		const response = await reqTipoProduto.listID(currentId);

		return response;
	};

	const insert = async (data) => {
		const response = await reqTipoProduto.insert(data);

		return response;
	};

	return (
		<RegisterProvider options={options} fetch={fetch} fetchID={fetchID} insert={insert}>
			<MainRegisterMatrix FormComponent={Form} FormFilter={FilterRegister} />
		</RegisterProvider>
	);
};

export default MainRegisterCategory;
